export default "__VITE_ASSET__8qS8br$U__"